import React, { useEffect, useRef, useState } from 'react'
import { Button, Modal, message } from 'antd'
import { inject, observer } from 'mobx-react'
import RichEditor from '../../components/RichEditor/RichEditor'

const InternalMessageEditContentModal = props => {
  const {
    isVisible,
    handleCancel,
    internalMessageStore,
    loadingAnimationStore,
    code,
    initialContent,
  } = props
  const editorRef = useRef()
  const [editorContent, setEditorContent] = useState(initialContent || '')

  useEffect(() => {
    if (isVisible) {
      setEditorContent(initialContent || '')
    }
  }, [isVisible, initialContent])

  const handleSubmit = async () => {
    const content = editorRef.current?.editor?.getData() || ''
    try {
      loadingAnimationStore.showSpinner(true)
      await internalMessageStore.updateContent(code, content)
      message.success('Cập nhật nội dung thành công!')
      handleCancel()
    } catch (error) {
      message.error(error?.vi || 'Cập nhật nội dung thất bại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <Modal
      title="Chỉnh sửa nội dung"
      visible={isVisible}
      onCancel={handleCancel}
      maskClosable={false}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Hủy
        </Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          Lưu
        </Button>,
      ]}>
      <RichEditor
        EDITOR_REF={editorRef}
        editorContent={editorContent}
        onEditorChange={setEditorContent}
        height={220}
      />
    </Modal>
  )
}

export default inject(
  'internalMessageStore',
  'loadingAnimationStore'
)(observer(InternalMessageEditContentModal))
